/**
 * `/agent?q=<question>` deep link, used by other pages (the Documents empty
 * state, the video library) to hand a question to the Knowledge Agent.
 * The page prefills the ask box with it — it never auto-submits.
 */

/** Same cap as the ask textarea's maxLength and the backend AskBody.query. */
export const QUESTION_MAX_CHARS = 8000;

/** The prefill question from the URL, or null when absent/blank. */
export function readQuestionParam(params: URLSearchParams): string | null {
  const raw = params.get('q');
  if (raw === null) return null;
  const question = raw.trim();
  // Setting a textarea's value from code bypasses maxLength, so cap here.
  return question ? question.slice(0, QUESTION_MAX_CHARS) : null;
}
